// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import OtherOverview from './OtherOverview';
import ChangePasswordPage from './ChangePasswordPage';
import EmailVerificationPage from './EmailVerificationPage';
import AccountLockedPage from './AccountLockedPage';
import TwoFactorSetupPage from './TwoFactorSetupPage';
import LogoutPage from './LogoutPage';

export default function OtherRoutes() {
  return (
    <Routes>
      <Route index element={<OtherOverview />} />
      <Route path="change-password" element={<ChangePasswordPage />} />
      <Route path="email-verification" element={<EmailVerificationPage />} />
      <Route path="account-locked" element={<AccountLockedPage />} />
      <Route path="two-factor-setup" element={<TwoFactorSetupPage />} />
      <Route path="logout" element={<LogoutPage />} />
    </Routes>
  );
}
